const DEFAULT_OPTIONS = {
  controls: true
};

class VideoPlayer {
  /**
   * Initializer
   *
   * @param {Element} elementRef - The element target for initialize JWPlayer.
   * @param {Object} options - The JWPlayer options.
   * */
  constructor(elementRef, options) {
    this.elementRef = elementRef;
    this.options = Object.assign({}, DEFAULT_OPTIONS, options);

    this.onReady = this.onReady.bind(this);

    this._setup();
  }

  /**
   * Play the video.
   */
  play() {
    if (!this.player) {
      return;
    }

    this.player.play();
  }

  /**
   * Pause the video.
   */
  pause() {
    if (!this.player) {
      return;
    }

    this.player.pause();
  }

  // Event

  /**
   * Event handler for signifies when the player has been initialized and is ready for playback.
   *
   * @param {Function} callback - The callback function.
   * */
  onReady(callback) {
    return this.player.on('ready', event => {
      callback(event);
    });
  }

  /**
   * Event handler for triggered when video playing in fullscreen mode.
   *
   * @param {Function} callback - The callback function.
   * */
  onFullScreen(callback) {
    return this.player.on('fullscreen', (event) => {
      callback(event);
    });
  }

  // Private

  /**
   * Setup the JWPlayer.
   * */
  _setup() {
    if (window.jwplayer) {
      this.player = window.jwplayer(this.elementRef);
      this.player.setup(this.options);
    }
  }
}

export default VideoPlayer;
